class TravelSimBuy {
	constructor(options) {
		this.state = {
			destination: null,
			region: null,
			product: null
		};
		this.destination_packs = [];
		this.wrapper = document.getElementById('buy_travel_sim');
		if (!this.wrapper) {
			throw new Error('Missing main wrapper element');
		}

		this.searchDataPacks = document.getElementById('search-data-packs');
		this.regionTabSelectors = document.querySelectorAll('.input-region-tab');
		this.productsWrapper = document.getElementById('region_products');
		this.page_url = '/buy/travel_sim';
		this.bannerContentWrapper = document.getElementById('country-banner-content');
		this.bannerContentHolder = document.getElementById('country-banner-holder');

		this.buyFormFields = {
			form: document.getElementById('form_buy_travel_sim'),
			productQuantity: this.wrapper.querySelector('[name="products[0][quantity]"]'),
			productProductIdentifier: this.wrapper.querySelector('[name="products[0][product_data][product_identifier]"]')
		}

		let _that = Object.assign(this, options);
		// console.log('TravelSimBuyWithRegions(%o)', _that);

		this.setRegionBinds();
		this.setProductBinds();
		this.updateState();
		this.onLanding();

		// Focus search field when
		this.benefitsBuyButton = document.getElementById('benefits_buy_button');
		this.benefitsBuyButton.addEventListener('click', () => {
			document.getElementById('search-data-packs').focus();
		});
	}

	async updateState() {
		if (this.state.destination?.name) {
			this.searchDataPacks.value = this.state.destination.name;
			await this.setRegionBinds();

			if (this.state.region) {
				await this.changeRegion(this.state.region);
				await this.setProductBinds();

				if (this.state.product) {
					await this.changeProduct(this.state.product);
				}
			}
		}

		if (this.state.destination.code &&
			this.banners &&
			Object.keys(this.banners).length > 0)
		{
			this.getCountryBanners(this.state.destination.code);
		}

		this.updateURL();
	}

	updateMetaTitle() {
		const amount = this.getMinSaleBySearchRegion(
			this.destination_packs.data.products,
			this.state.region,
		);

		document.title = s.it('TRAVEL_SIM_BUY_COUNTRY_META_TITLE', {
			'country': this.state.destination.name,
			'amount': s.format_money(amount),
		});
	}

	getMinSaleBySearchRegion(products, region) {
		const sales = products
			.filter(product => product.region === region)
			.map(product => product.sale);

		return sales.length ? Math.min(...sales) : 0;
	}


	updateURL() {
		const url = new URL(window.location.href);
		url.searchParams.delete('destination');
		url.searchParams.delete('region');
		url.searchParams.delete('hash');
		let newURL = this.page_url;

		if (this.state.destination?.name) {
			newURL += '/' + encodeURIComponent(this.state.destination.name);
			if (this.state.region) {
				newURL += '/' + encodeURIComponent(this.state.region);
			}
		}
		url.pathname = s.url(newURL);

		window.history.replaceState(this.state, '', url.toString());
	}

	async setRegionBinds() {
		if (this.regionTabSelectors) {
			this.regionTabSelectors.forEach(regionSelector => {
				regionSelector.disabled = false;
				regionSelector.addEventListener('change', async e => {
					e.preventDefault();
					this.state.region = regionSelector.dataset.regionType;
					this.state.product = null;
					await this.changeRegion(this.state.region);
					await this.changeProduct(this.state.product);
				});
			});
		}
	}

	async setProductBinds() {
		if (this.productsWrapper) {
			const products = this.productsWrapper.querySelectorAll('.product');
			products?.forEach(product => {
				product.disabled = false;
				product.addEventListener('click', () => {
					products.forEach(p => {
						p.classList.remove('active');
						p.classList.add('inactive');
					});
					product.classList.remove('inactive');
					product.classList.add('active');

					if (product.dataset.displayType === 'product') {
						this.state.product = {
							displayType: product.dataset.displayType,
							amount: product.dataset.sale,
							identifier: product.dataset.productIdentifier,
							externalId: product.dataset.productExternalId,
							operatorId: product.dataset.productOperatorId,
							urlHash: product.dataset.urlHash
						};
						this.changeProduct(this.state.product);
					}
				});
			});
		}
	}

	changeRegionTitle(showProductTitle) {
		const productsHeadingTitle = document.querySelectorAll('.products-heading-title');
		productsHeadingTitle?.forEach(title => {
			const isProductTitle = title.dataset.productType === 'product';
			title.classList.toggle('d-none', showProductTitle ? !isProductTitle : isProductTitle);
		});
	}

	async changeRegion(region) {
		if (this.regionTabSelectors) {
			const activeInputTab = this.wrapper.querySelector(`.input-region-tab[data-region-type='${region}']`);
			if (activeInputTab) activeInputTab.checked = true;

			if (
				this.state.destination?.name &&
				this.destination_packs?.data?.products &&
				this.destination_packs?.status === 'successful'
			) {
				this.updateMetaTitle();
			}
		}

		if (this.productsWrapper) {
			const products = this.productsWrapper.querySelectorAll('.product');
			let productsByRegion = [];

			products?.forEach(product => {
				const isProductInRegion = product.dataset.region === region;
				product.classList.toggle('d-none', !isProductInRegion);
				product.classList.remove(...['blur', 'inactive']);

				if (isProductInRegion) {
					productsByRegion.push(product);
					this.changeRegionTitle(product.dataset.displayType === 'product');
				}
			});

			if (productsByRegion.length === 1) {
				const singleProduct = productsByRegion[0];
				if (singleProduct.dataset.displayType === 'product') {
					this.state.product = {
						displayType: singleProduct.dataset.displayType,
						amount: singleProduct.dataset.sale,
						identifier: singleProduct.dataset.productIdentifier,
						externalId: singleProduct.dataset.productExternalId,
						operatorId: singleProduct.dataset.productOperatorId,
						urlHash: singleProduct.dataset.urlHash
					};
					singleProduct.classList.add('active');
				}
			}
		}

		this.updateURL();
	}

	async changeProduct(product) {
		if (product && product.displayType === 'product') {
			this.buyFormFields.productQuantity.value = product.amount;
			this.buyFormFields.productProductIdentifier.value = product.identifier;
			this.buyFormFields.form.querySelector('button[type=submit]').disabled = false;
		} else {
			if (this.productsWrapper) {
				const products = this.productsWrapper.querySelectorAll('.product');
				products?.forEach(product => {
					product.classList.remove('active');
				});
			}

			this.buyFormFields.productQuantity.value = '';
			this.buyFormFields.productProductIdentifier.value = '';
			this.buyFormFields.form.querySelector('button[type=submit]').disabled = true;
		}

		this.updateURL();
	}

	onLanding() {
		const urlParams = new URLSearchParams(window.location.search);
		const externalProductId = urlParams.get('external_product_id');

		if (!externalProductId) {
			return;
		}
		const product = document.querySelector(`[data-product-external-id='${externalProductId}']`);

		if (!product) {
			return;
		}
		const region = product.dataset.region || 'local';

		if (region && document.getElementById(`region-tab-${region}`)) {
			document.getElementById(`region-tab-${region}`).click();
		}
		product.click();
	}
	getCountryBanners(countryCode) {
		let travelSimBanners = this?.banners;
		if (travelSimBanners) {
			let banners = travelSimBanners.banners;
			let selectedCountryBanners = banners[countryCode];

			selectedCountryBanners?.forEach(banner => {
				let bannerContent = document.createElement('div');
				let bannerMessage = document.createElement('div');
				bannerContent.classList.add('banner-content', 'mt-10');
				bannerContent.setAttribute('data-country-code', countryCode);
				bannerMessage.classList.add('banner-message', 'flex-grow-1');
				bannerMessage.innerHTML = banner.message;

				if (banner.message_type === 'text') {
					bannerContent.appendChild(bannerMessage);
					bannerContent.classList.add('banner-content-icon');
					if (banner.promotion_icon_svg) {
						bannerContent.insertAdjacentHTML('afterbegin', `<svg viewBox="0 0 42 42"><use xlink:href="#${banner.promotion_icon_svg}"></use></svg>`);
					}
				} else {
					if (typeof banner.terms !== 'undefined' && banner.terms !== '') {
						let uniqueId = ((length) => {
							let result = '';
							let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
							let charactersLength = characters.length;
							for (let i = 0; i < length; i++) {
								result += characters.charAt(Math.floor(Math.random() * charactersLength));
							}
							return result;
						})(20);

						bannerContent.setAttribute('data-toggle', 'collapse');
						bannerContent.setAttribute('href', "#".concat(uniqueId));
						bannerContent.setAttribute('role', 'button');
						bannerContent.setAttribute('aria-expanded', 'false');
						bannerContent.setAttribute('aria-controls', 'collapseExample');

						let chevron = s.svg(
							'chevron-large-down',
							'0 0 24 24',
							['collapse-chevron', 'collapsed'],
							{},
							{},
							'',
							''
						);

						let bannerTermsHolder = document.createElement('div');
						bannerTermsHolder.classList.add('d-flex', 'align-items-center');
						bannerTermsHolder.appendChild(bannerMessage);
						bannerTermsHolder.innerHTML += chevron;

						let bannerTerms = document.createElement('div');
						bannerTerms.setAttribute('id', uniqueId);

						if (banner.display_content) {
							if (banner.display_content ?? true) {
								bannerContent.setAttribute('aria-expanded', 'true');
								bannerTerms.classList.add('banner-terms', 'collapse', 'show');
							} else {
								bannerTerms.classList.add('banner-terms', 'collapse');
							}
						} else {
							bannerTerms.classList.add('banner-terms', 'collapse');
						}

						let bannerTermsWrapper = document.createElement('div');
						bannerTermsWrapper.classList.add('pt-10');
						bannerTermsWrapper.innerHTML = banner.terms;
						bannerTerms.appendChild(bannerTermsWrapper);

						bannerContent.appendChild(bannerTermsHolder);
						bannerContent.appendChild(bannerTerms);
					}
				}

				this.bannerContentWrapper.appendChild(bannerContent);
				this.bannerContentHolder.classList.remove('d-none');
			})
		}
	}
}
